import { httpClient } from '../utils/httpClient';
import { HorarioPayload, HorarioResponse, HorarioImpresionResponse } from '../types/horario.types';
import { AsignacionItem } from '../types/matricula.types';

// ============================================================
// horarioService.ts
// ============================================================

export const horarioService = {

  async listar(): Promise<HorarioResponse[]> {
    return httpClient.get<HorarioResponse[]>('/horarios');
  },

  async obtener(id: number): Promise<HorarioResponse> {
    return httpClient.get<HorarioResponse>(`/horarios/${id}`);
  },

  async crear(payload: HorarioPayload): Promise<HorarioResponse[]> {
    return httpClient.post<HorarioResponse[]>('/horarios', payload);
  },

  async modificar(id: number, payload: HorarioPayload): Promise<HorarioResponse> {
    return httpClient.put<HorarioResponse>(`/horarios/${id}`, payload);
  },

  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/horarios/${id}`);
  },

  async listarPorEstudiante(estudianteId: number, anioEscolarId: number): Promise<HorarioResponse[]> {
    return httpClient.get<HorarioResponse[]>(
      `/horarios/estudiante/${estudianteId}/anio/${anioEscolarId}`
    );
  },

  async listarPorDocente(docenteId: number, anioEscolarId: number): Promise<HorarioResponse[]> {
    return httpClient.get<HorarioResponse[]>(
      `/horarios/docente/${docenteId}/anio/${anioEscolarId}`
    );
  },

  async listarPorAnio(anioId: number): Promise<HorarioResponse[]> {
    return httpClient.get<HorarioResponse[]>(`/horarios/anio/${anioId}`);
  },

  async listarPorAnioNivel(anioId: number, nivel: string): Promise<HorarioResponse[]> {
    return httpClient.get<HorarioResponse[]>(`/horarios/anio/${anioId}/nivel/${nivel}`);
  },

  async listarPorAnioNivelGrado(anioId: number, nivel: string, gradoId: number): Promise<HorarioResponse[]> {
    return httpClient.get<HorarioResponse[]>(`/horarios/anio/${anioId}/nivel/${nivel}/grado/${gradoId}`);
  },

  async listarFiltrado(anioId: number, nivel: string, gradoId: number, seccionId: number): Promise<HorarioResponse[]> {
    return httpClient.get<HorarioResponse[]>(
      `/horarios/anio/${anioId}/nivel/${nivel}/grado/${gradoId}/seccion/${seccionId}`
    );
  },

  async obtenerImpresion(params: {
    anioEscolarId: number;
    nivel: string;
    gradoId?: number;
    seccionId?: number;
  }): Promise<HorarioImpresionResponse> {
    const { anioEscolarId, nivel, gradoId, seccionId } = params;
    const qs = new URLSearchParams({ anioEscolarId: String(anioEscolarId), nivel });
    if (gradoId)   qs.set('gradoId',   String(gradoId));
    if (seccionId) qs.set('seccionId', String(seccionId));
    return httpClient.get<HorarioImpresionResponse>(`/horarios/impresion?${qs.toString()}`);
  },
};

// ── Obtener todas las asignaciones académicas (para el selector) ──
export const asignacionesTodasService = {
  async listar(signal?: AbortSignal): Promise<AsignacionItem[]> {
    try {
      const data = await httpClient.get<AsignacionItem[]>('/asignaciones', signal ? { signal } : undefined);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      // Relanzar para que el llamador distinga timeout/abort de error real
      if (e instanceof Error && (e.name === 'AbortError' || e.name === 'TimeoutError')) throw e;
      return [];
    }
  },
};
